import { combineReducers } from 'redux';

import contactUsError from './contactUsError';


export default combineReducers({
  contactUsError,
});
